import axios from "axios";
import config from "../config/config";

const TOKEN_QUERY = /([?&]api_token=)[^&]*/gi;

export function sanitizePlayCricketUrl(url) {
  if (!url) return "";
  return String(url).replace(TOKEN_QUERY, "$1REDACTED");
}

export function logPlayCricketResponse({
  endpoint,
  requestUrl,
  httpStatus = 200,
  isSuccess = true,
  rawResponse = null,
  errorMessage = "",
}) {
  try {
    const sourcePage =
      typeof window !== "undefined"
        ? `${window.location.pathname}${window.location.search}`
        : "";

    axios
      .post(
        `${config.apiBaseURL}play-cricket-logs/`,
        {
          endpoint,
          request_url: sanitizePlayCricketUrl(requestUrl),
          source_page: sourcePage,
          http_status: httpStatus,
          is_success: isSuccess,
          raw_response: rawResponse,
          error_message: errorMessage || "",
        },
        {
          headers: { "Content-Type": "application/json" },
          timeout: 20000,
        }
      )
      .catch(() => {});
  } catch (err) {
    // Logging must never break Play-Cricket pages.
  }
}
